// 活动页面路由
import { BEAUTY_PREVIEW_PATH } from '@/assets/js/product';

export default [
  {
    path: '/beauty',
    name: 'Beauty',
    meta: {
      pos: 0,
      cnName: '笔刷专题页',
    },
    component: () => import('@/views/beauty/Beauty.vue').then((r) => r.default || r),
  },
  {
    path: BEAUTY_PREVIEW_PATH, // /beauty 的魔方预览页面
    name: 'BeautyPreView',
    meta: {
      pos: 0,
      cnName: '笔刷专题页-魔方预览页',
    },
    component: () => import('@/views/beauty/Beauty.vue').then((r) => r.default || r),
  },
  {
    path: '/point-mall',
    name: 'PointMall',
    meta: {
      pos: 0,
      cnName: '积分兑换商城页',
    },
    component: () => import('@/views/point-mall/PointMall.vue').then((r) => r.default || r),
  },
  {
    path: '/flash-sale',
    name: 'FlashSale',
    meta: {
      pos: 0,
      cnName: '闪购页',
    },
    component: () => import('@/views/flash-sale/FlashSale.vue').then((r) => r.default || r),
  },
  {
    path: '/clearance',
    name: 'Clearance',
    meta: {
      pos: 0,
      cnName: '定向清仓页面',
    },
    component: () => import('@/views/flash-sale/Clearance.vue').then((r) => r.default || r),
  },
  {
    path: '/8029fb6949061c89', // flash-sale魔方预览页面
    name: 'FlashSalePreview',
    meta: {
      pos: 0,
      cnName: '闪购页',
    },
    component: () => import('@/views/flash-sale/FlashSale.vue').then((r) => r.default || r),
  },
  {
    // 魔方配置的活动页，用于app引流
    path: '/activity-page',
    name: 'ActivityPage',
    component: () => import('@/views/activity/activity-page.vue').then((r) => r.default || r),
  },
  {
    path: '/black-friday-deals', // 黑五活动页新URL
    name: 'Bfcm2025',
    component: () => import('@/views/activity/bfcm2025/Bfcm2025.vue').then((r) => r.default || r),
    meta: {
      cnName: '黑五活动页',
    },
  },
  {
    path: '/offline-page',
    name: 'OfflinePage',
    meta: {
      pos: 0,
    },
    component: () =>
      import('@/views/activity/offline-page/offline-page.vue').then((r) => r.default || r),
  },
  {
    path: '/half-frame-glasses',
    name: 'HalfFrame',
    meta: {
      pos: 0,
      cnName: '半框专题页',
    },
    component: () =>
      import('@/views/activity/half-frame/HalfFrame.vue').then((r) => r.default || r),
  },
  {
    path: '/ambassador',
    name: 'Ambassadors',
    meta: {
      pos: 0,
      cnName: '大使落地页',
    },
    component: () => import('@/views/ambassadors/Ambassadors.vue').then((r) => r.default || r),
  },
  {
    path: '/ambassador/represents',
    name: 'Represents',
    meta: {
      pos: 0,
      cnName: '大使列表页',
    },
    component: () => import('@/views/ambassadors/Represents.vue').then((r) => r.default || r),
  },
  {
    path: '/ambassador/profile/:name',
    name: 'ProfilePage',
    meta: {
      pos: 0,
      cnName: '大使作品详情页',
    },
    component: () => import('@/views/ambassadors/ProfilePage.vue').then((r) => r.default || r),
  },
  {
    path: '/anniversary-deals',
    name: 'Anniversary2025',
    meta: {
      pos: 0,
      cnName: '周年庆活动页',
    },
    // 活动已结束，直接重定向到首页
    redirect: '/',
  },
  {
    path: '/vooglam-tombogo-collection',
    name: 'TomBogoCollection',
    meta: {
      pos: 0,
      cnName: 'TomBogo发售页',
      keepalive: true,
    },
    component: () =>
      import('@/views/activity/tombogo-collection/TomBogoCollection.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/collections/bloody-opium',
    name: 'BloodyOpiumCollection',
    meta: {
      pos: 0,
      cnName: '血腥鸦片新品营销发售专题页',
      keepalive: true,
    },
    component: () =>
      import('@/views/activity/bloody-opium/BloodyOpiumCollection.vue').then((r) => r.default || r),
  },
  {
    path: '/collections/valentines-day-eyewear',
    redirect: '/campaigns/valentines-day-eyewear',
  },
  {
    path: '/campaigns/valentines-day-eyewear',
    name: 'ValentinesDayEyewear',
    meta: {
      pos: 0,
      cnName: '26年情人节活动页',
    },
    component: () =>
      import('@/views/activity/valentines-day-eyewear/ValentinesDayEyewear.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/campaigns/colortints',
    name: 'ColorTint',
    meta: {
      pos: 0,
      cnName: 'Color Tint 专题页',
      keepalive: true,
    },
    component: () =>
      import('@/views/activity/color-tint/ColorTint.vue').then((r) => r.default || r),
  },
  {
    path: '/campaigns/vacation-sunglasses',
    name: 'VacationSunglasses',
    meta: {
      pos: 0,
      cnName: '26年度假季专题页',
    },
    component: () =>
      import('@/views/activity/vacation-sunglasses/VacationSunglasses.vue').then(
        (r) => r.default || r,
      ),
  },
  {
    path: '/collections/moto-boho',
    name: 'MotoBohoCollection',
    meta: {
      pos: 0,
      cnName: 'MotoBoho新品专题页',
    },
    component: () =>
      import('@/views/activity/moto-boho/MotoBohoCollection.vue').then((r) => r.default || r),
  },
  // {
  //   path: '/rhnX5EwP',
  //   name: 'TomBogoCollectionPreview',
  //   meta: {
  //     pos: 0,
  //     cnName: 'TBG发售页',
  //     keepalive: true,
  //   },
  //   component: () =>
  //     import('@/views/activity/tombogo-collection/TomBogoCollection.vue').then(
  //       (r) => r.default || r,
  //     ),
  // },
];
